import React from 'react';

import SvgIcon from "../../SharedComponents/Icons";

import './index.sass';


const DetailsInfo = ({ guestCapacityFrom, guestCapacityTo, permitsOwnCatering, pricePerSeat }) => {

  return (
    <div className="details-info-section">
      { (guestCapacityFrom || guestCapacityTo) &&
        <div className="details-info-section__info-block">
          <SvgIcon name="users2" size={22} />
          { guestCapacityFrom && guestCapacityTo
            ? `${guestCapacityFrom} - ${guestCapacityTo} gæster`
            : guestCapacityFrom
              ? `Fra ${guestCapacityFrom} gæster`
              : `Op til ${guestCapacityTo} gæster`
          }
        </div>
      }
      { pricePerSeat &&
        <div className="details-info-section__info-block">
          <SvgIcon name="price" size={22} />
          Fra <span>{ pricePerSeat } kr.</span> pr. kuvert
        </div>
      }

      { permitsOwnCatering &&
        <div className="details-info-section__info-block">
          <SvgIcon name="catering" size={22} />
          Egen forplejning tilladt
        </div>
      }
    </div>
  )
}

export default DetailsInfo;
